module.exports = __webpack_public_path__ + "img/icon-3.bb24ab5d.svg";